module.exports = __webpack_public_path__ + "img/v4_expetionLog_h.a4027559.png";